import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store/store'
import { ISpecialPogram, ISpecialPogramState, TError } from 'entities/insurance-contract/special-pogram/types/SpecialPogram-interface'

const SpecialPogramState = (state: RootState): ISpecialPogramState => state.specialPogramCase

export const SpecialPogramInfo = createSelector(
    [SpecialPogramState],
    (state): ISpecialPogram => state.specialPogram,
)
export const LoadingSpecialPogramInfo = createSelector(
    [SpecialPogramState],
    (state): boolean => state.isLoadingSpecialPogram,
)
export const ErrorSpecialPogramInfo = createSelector(
    [SpecialPogramState],
    (state): TError => state.errorSpecialPogram,
)

export const LastFetchTimeSpecialPogramInfo = createSelector(
    [SpecialPogramState],
    (state): null | number => state.lastFetchTime,
)
export const IdCaseSpecialPogramInfo = createSelector(
    [SpecialPogramState],
    (state):  null | string => state.idCase,
)